import { useContext, useCallback } from "react";
import { FapHouseContext } from "../contexts/FapHouseContext";

/**
 * Hook to trigger a FapHouse video search from any component.
 * Usage: const { searchFapHouse } = useFapHouseSearch();
 *        searchFapHouse("latina");
 */
export const useFapHouseSearch = () => {
  const { loadVideos } = useContext(FapHouseContext);

  const searchFapHouse = useCallback(
    (keyword = "", orientation = "straight") => {
      loadVideos({ keyword, orientation, quantity: 20 });
    },
    [loadVideos]
  );

  return { searchFapHouse };
};
